export const getRealmUrl = (publicIdentity) => {
  if (!publicIdentity?.length) return false;
  const subStringStart = publicIdentity.indexOf("@") + 1;

  return publicIdentity.substring(subStringStart);
};
